const manutencao_equivalencia_estudos = {
  path: "/manutencao_equivalencia_estudos",
  redirect: "/manutencao_equivalencia_estudos",
  meta: {
    breadCrumb: "Gerenciamento de Matrícula - Parâmetros por Escolaridade",
  },
  children: [
    {
      path: "/manutencao_equivalencia_estudos/novo",
      name: "manutencaoequivalenciaestudos_novo",
      meta: {
        allowedPermissions: ["equivalencia_ensino_create"],
      },
      component: () =>
        import(
          "@/views/ManutencaoEquivalenciaEstudos/ManutencaoEquivalenciaEstudosCad.vue"
        ),
    },
    {
      path: "/manutencao_equivalencia_estudos/edit/:id",
      name: "manutencaoequivalenciaestudos_atualizar",
      meta: {
        allowedPermissions: ["equivalencia_ensino_edit"],
      },
      component: () =>
        import(
          "@/views/ManutencaoEquivalenciaEstudos/ManutencaoEquivalenciaEstudosEdit.vue"
        ),
    },
    {
      path: "/manutencao_equivalencia_estudos",
      name: "manutencaoequivalenciaestudos",
      meta: {
        allowedPermissions: ["equivalencia_ensino_index"],
      },
      component: () =>
        import(
          "@/views/ManutencaoEquivalenciaEstudos/ManutencaoEquivalenciaEstudosHome.vue"
        ),
    },
  ],
};

export { manutencao_equivalencia_estudos };
